// extracted by mini-css-extract-plugin
export default {"container":"IntelligentWarning_container__AyKml","titleArea":"IntelligentWarning_titleArea__P27vH","title":"IntelligentWarning_title__RsVcP"};